import React from 'react';
import './TopDesc.css'

const TopDesc = () => {
    return (
        <div className="contact-info">
            <div className="phone">
                <i className="fas fa-phone"></i> {/* Assuming you're using Font Awesome for icons */}
                <span>01-4571040</span>
            </div>
            <div className="phone">
                <i className="fas fa-mobile"></i> {/* Assuming you're using Font Awesome for icons */}
                <span>9851206644, 9869182611</span>
            </div>
            <div className="email">
                <i className="fas fa-envelope"></i>
                <span>info@abchealthcaresolutions.com</span> {/* it is the email address to login the mail  */}
            </div>
            <div className="social-icons-1">
                <a href="https://www.facebook.com/abchealthcaresolution/" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://www.instagram.com/example" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                </a>
                <a href="https://www.linkedin.com/in/arjun-chand-a68a8a147/?originalSubdomain=np" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin"></i>
                </a>
            </div>
        </div>
    );
}

export default TopDesc;
